import { render, staticRenderFns } from "./ModalAgendarAvaliacao.vue?vue&type=template&id=3039d5b5"
import script from "./ModalAgendarAvaliacao.vue?vue&type=script&lang=js"
export * from "./ModalAgendarAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports